var React = require('react');

function CellPhone (props) {
    return React.createElement("svg",props);
}

CellPhone.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000"};

module.exports = CellPhone;

CellPhone.default = CellPhone;
